!function($) {

  // Add custom JavasScript here
  // --------------------------

  // Envision - collapsable page content block scripts
  $(function() {
    console.log('ready');
    if ($('.collapsable-page-content-component').length) {
      $('.collapsable-page-content-component a[data-content-toggle]').on('click', function(e) {
        e.preventDefault();
        $(this).parents('.collapsable-page-content-component').toggleClass('active');
      });
    }
  });

  // Envision - books-in-bulk quantity selectors
  $(function() {
    let bulkQtyComponent = $('.variants form .bulk-qty-selector-component');
    let qtyInputs, qtyElement;
    
    if (bulkQtyComponent.length) {
      init();
    }

    function init() {
      qtyInputs = $('input.option-input[type="checkbox"]', bulkQtyComponent);
      qtyElement = $('.variants form .item.qty-selector');
      
      qtyInputs.on('change', function() {
        let currentValue = $(this).val();
        console.log({
          "standard": currentValue,
          "parsed": parseInt(currentValue, 10)
        });
        currentValue = parseInt(currentValue, 10);
        qtyInputs.filter(`:not([value="${currentValue}"])`).prop('checked', false);

        if ($(this).is(':checked')) {
          qtyElement.find('input[name="quantity"]').val(currentValue);
          disableQtyElement();
        } else {
          enableQtyElement();
        }
      });

      $(qtyElement).on('click', () => {
        enableQtyElement();
      });
      
    }

    function disableQtyElement() {
      qtyElement.addClass('disabled');
      //$('input[name="quantity"]', qtyElement).prop('disabled', true);
    }

    function enableQtyElement() {
      qtyInputs.prop('checked', false);
      qtyElement.removeClass('disabled');
      //$('input[name="quantity"]', qtyElement).prop('disabled', false);
    }
  });
}(jQuery);